<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="detailDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="1200px"
            center>
        <div class="dialog-container flex flex-direction ">
            <div class="dialog-header flex align-center justify-between flex-shrink">
                <div class="flex align-center">
                    <el-image class="header-logo" :src="orginizInfo.logo" v-if="orginizInfo.logo"></el-image>
                    <img src="../../../assets/img/defailt-avatar.png" alt="" class="logo" v-else/>
                    <div class="header-name">{{orginizInfo.name}}</div>
                </div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>

            <div class="dialog-content flex flex-direction">
                <div class="title">{{detail.title}}</div>
                <div class="content flex flex-direction">
                    <div  v-html="detail.content"></div>
                    <div class="time self-end">{{orginizInfo.name}}</div>
                    <div class="time self-end">{{detail.create_time}}</div>
                </div>
            </div>
            <div class="dialog-operate flex align-center justify-center">
                <el-button class="operate black" @click="cancel">关闭</el-button>
            </div>
            <div class="dialog-footer flex align-center justify-around flex-shrink">
                <div class="content">{{orginizInfo.name}}</div>
                <div class="content">电话：{{orginizInfo.lianxidianhua}}</div>
                <div class="content">邮箱：{{orginizInfo.email}}</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {getActiveDetail, showOrgFenHui} from '@/api/branch'
    export default {
        name: "ActiveDetailDialogPerview",
        props: {
            detailDialogVisible: {
                type: Boolean,
                default: false
            },
            aid: { //详情ID
                type: Number,
            },
        },
        data() {
            return {
                detail: '',
                orginizInfo: ''
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        created() {
            this.getOrganizInfo()
        },
        methods: {
            async getOrganizInfo() {
                let _data = await showOrgFenHui(this.user.fhid)
                if (_data.status === 200) {
                    this.orginizInfo = _data.data
                }

            },
            async init() {
                let _data = await  getActiveDetail(this.aid)
                if (_data.status === 200) {
                    this.detail = _data.data
                }
            },
            cancel() {
                this.$emit('watchState', false)
            }
        },
        watch: {
            detailDialogVisible() {

            },
            aid() {
                if (this.aid) {
                    this.detail = ''
                    this.init()
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .detail-dialog-container {
        .dialog-container {
            height: 800px;
            .dialog-header {
                height: 55px;
                padding: 0 20px;
                border-bottom: 1px solid #eeeeee;
                .header-logo {
                    width: 30px;
                    height: 30px;
                    border-radius: 30px;
                }
                .header-name {
                    font-size: 16px;
                    color: #0a2240;
                    margin-left: 6px;
                }
                .dialog-close {
                    font-size: 21px;
                    color: #0a2240;
                    font-weight: bold;
                    cursor: pointer;
                }
            }
            .dialog-content {
                padding: 40px 80px;
                height: 605px;
                .title {
                    font-size: 24px;
                    font-weight: bold;
                    color: #0a2240;
                    text-align: center;
                }
                .content {
                    margin-top: 38px;
                    overflow-y: scroll;
                    &::-webkit-scrollbar {
                        display: none
                    }
                }
                .time{
                    font-size: 16px;
                    color: #0a2240;
                    margin-top: 16px;
                }
            }
            .dialog-operate {
                height: 100px;
                .operate {
                    width: 200px;
                    height: 40px;
                    border-radius: 20px;
                    font-size: 16px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#ff9600, #ff9600);
                    background-blend-mode: normal, normal;
                    color: #ffffff;
                    &.black {
                        background: #0a2240 none;
                    }
                }
                .operate+.operate{
                    margin-left: 80px;
                }
            }
            .dialog-footer {
                height: 40px;
                background-color: #e7eff9;
                padding: 0 20px;
                border-radius: 0 0 10px 10px;
                .content {
                    font-size: 16px;
                    color: #8b9fbe;
                }
            }
        }
    }
</style>
